import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Feature, Marker } from 'react-mapbox-gl';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import {
    LibraryAdd as AddSiteCardIcon
    // ExitToAppIcon as ViewSiteCardIcon
} from '@material-ui/icons';
import PropTypes from 'prop-types';
import { Box, IconButton, Switch, Tooltip, Typography } from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import DraggableMarker from '../../Mapbox/DraggableMarker';
import CreateSiteCardDialog from '../../Common/SiteCard/CreateDialog';



function isValidHttpUrl (string) {
    let url;
    try {
        url = new URL(string);
    } catch (_) {
        return false;
    }
    return url.protocol === 'http:' || url.protocol === 'https:';
}

class QueryFeatureInfoBox extends React.Component {
    static propTypes = {
        siteCard: PropTypes.object,
    };
    constructor (props) {
        super(props);
        this.state = {
            featureIndex: 0,
            modalOpen: true,
            isCreateSiteCardDialogOpen: false
        };
        this.openCreateSiteCardDialog = this.openCreateSiteCardDialog.bind(this);
        this.closeCreateSiteCardDialog = this.closeCreateSiteCardDialog.bind(this);
    }

    openCreateSiteCardDialog () {
        this.setState({ isCreateSiteCardDialogOpen: true });
    }

    closeCreateSiteCardDialog () {
        this.setState({ isCreateSiteCardDialogOpen: false });
    }

    capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    componentDidUpdate (prevProps, prevState) {
        const { highlightedFeatures } = this.props;
        if (highlightedFeatures.length > 0 && !_.isEqual(highlightedFeatures, prevProps.highlightedFeatures)) {
            this.setState({ featureIndex: 0, modalOpen: true });
        }
    }

    render () {
        const { classes, highlightedFeatures, activeLayers, layers, siteCard } = this.props;
        const { featureIndex, modalOpen, isCreateSiteCardDialogOpen } = this.state;
        if (highlightedFeatures.length === 0 || !modalOpen) {
            return null;
        }
        let features = [];
        for (const featureList of highlightedFeatures) {
            if (activeLayers.find(al => al.systemName === featureList.layerSystemName)) {
                const layer = layers.find(l => l.system_name === featureList.layerSystemName);
                if (layer.query) {
                    for (const f of featureList.features) {
                        if (f.properties && f.lngLat) {
                            features.push(f);
                        }
                    }
                }
            }
        }
        features = features.filter((v, i, s) => i === s.findIndex(item => _.isEqual(item, v)));
        features.sort((a, b) => new Date(b?.properties?.start_date) - new Date(a?.properties?.start_date));
        const feature = features[featureIndex];
        if (!feature) {
            return null;
        }
        const selectedLayer = layers.find(l => l.system_name === highlightedFeatures.find(hf => hf.features.find(f => f.featureId === feature.featureId)).layerSystemName);
        const label = feature.properties[selectedLayer.properties.label];
        console.log('label', label);
        console.log('feature.id', feature.id);
        console.log('dialog', isCreateSiteCardDialogOpen);
        return (
            <Marker
                key={feature.featureId}
                anchor="bottom-left"
                coordinates={feature.lngLat}
            >
                { isCreateSiteCardDialogOpen && <CreateSiteCardDialog
                    open={isCreateSiteCardDialogOpen}
                    onClose={this.closeCreateSiteCardDialog}
                    featureConfig={{
                        layerId: selectedLayer.id,
                        featureId: feature.featureId
                    }}
                    defaultName={label}
                />}
                <div id={feature.featureId}>
                    <div className={classes.header}>
                        <Typography
                            variant="caption"
                            color="textPrimary"
                            className={classes.layerName}
                        >
                            {selectedLayer.name}
                        </Typography>
                        <div className={classes.pages}>
                            { (features.length > 1 && featureIndex > 0) ? <KeyboardArrowLeftIcon
                                id="query-prev-button"
                                className={`${classes.contrastText} ${classes.pointer} ${classes.autoPointerEvents}`}
                                fontSize="small"
                                onClick={(e) => this.setState({ featureIndex: featureIndex - 1 })}
                            /> : <div className={classes.fillerIcon}></div> }
                            <Typography
                                variant="subtitle2"
                                color="textPrimary"
                                className={classes.pageText}
                            >
                                {featureIndex + 1} / {features.length}
                            </Typography>
                            { (features.length > 1 && featureIndex < (features.length - 1)) ? <KeyboardArrowRightIcon
                                id="query-next-button"
                                style={{ paddingRight: '5px' }}
                                className={`${classes.contrastText} ${classes.pointer} ${classes.autoPointerEvents}`}
                                fontSize="small"
                                onClick={(e) => this.setState({ featureIndex: featureIndex + 1 })}
                            /> : <div className={classes.fillerIcon}></div> }
                        </div>
                    </div>
                    <div className={classes.markerContainer}>
                        <div className={classes.title}>
                            <Typography
                                variant="subtitle1"
                                color="textPrimary"
                                className={classes.titleText}
                            >
                                {label}
                            </Typography>
                            <CloseIcon
                                id="query-close-button"
                                className={`${classes.contrastText} ${classes.pointer} ${classes.autoPointerEvents}`}
                                fontSize="small"
                                onClick={(e) => this.setState({ modalOpen: false })}
                            />
                        </div>
                        <div className={classes.properties}>
                            { selectedLayer.properties.primary.map((rawProp, j) => {
                                if (typeof rawProp !== 'string') {
                                    return null;
                                }
                                const prop = rawProp;
                                if (prop && prop.includes('/')) {
                                    const [id, name] = prop.split('/');
                                    if (selectedLayer.properties.id === id) {
                                        return null;
                                    }
                                    return feature.properties[id] && (
                                        <Typography
                                            key={j}
                                            variant="subtitle2"
                                            color="textPrimary"
                                            className={classes.property}
                                        >
                                            <strong>{this.capitalizeFirstLetter(name)}:&nbsp;</strong>
                                            {isValidHttpUrl(feature.properties[id]) ? <a href={feature.properties[id]} className={classes.link} target="_blank">
                                                {feature.properties[id]}
                                            </a> : feature.properties[id]}
                                        </Typography>
                                    );
                                }
                                if (selectedLayer.properties === prop) {
                                    return null;
                                }
                                return feature.properties[prop] && (
                                    <Typography
                                        key={j}
                                        variant="subtitle2"
                                        color="textPrimary"
                                        className={classes.property}
                                    >
                                        <strong>{this.capitalizeFirstLetter(prop)}:&nbsp;</strong>
                                        {isValidHttpUrl(feature.properties[prop]) ? <a href={feature.properties[prop]} className={classes.link} target="_blank">
                                            {feature.properties[prop]}
                                        </a> : feature.properties[prop]}
                                    </Typography>
                                ); 
}) }
 {selectedLayer.properties.id === 'inspireid' && !siteCard && (
    <Tooltip arrow title="Create Site Card" placement="right">
                                            <Box color="primary.contrastText">
                                                <IconButton
                                                    onClick={this.openCreateSiteCardDialog}
                                                    // disabled={selectedPolygon?.isLite || selectedPolygon?.isFetchingPolygon || selectedPolygon?.isFetchingIntersections || selectedPolygon?.isFetchingAreaInfo}
                                                >
                                                    <AddSiteCardIcon />
                                                </IconButton>
                                            </Box>
                                        </Tooltip>
    )}
    {selectedLayer.properties.id === 'inspireid' && siteCard && (
        <Link to={`/dashboard/sites/${siteCard.id}`}>
            <Tooltip arrow title="View Site Card" placement="right">
                <Box color="primary.light">
                    <IconButton
                        color="inherit"
                        onClick={() => {}}
                    >
                        <ExitToAppIcon />
                    </IconButton>
                </Box>
            </Tooltip>
        </Link>
    )}
                        </div>
                    </div>
                </div>
            </Marker>
        );
    }
}

const styles = (theme) => ({
    markerContainer: {
        zIndex: '10000 !important',
        width: '300px',
        height: '200px',
        backgroundColor: theme.palette.background.main,
        border: '1px solid ' + theme.palette.grey.variant3,
        display: 'flex',
        flexDirection: 'column'
    },
    markerContainer2: {
        zIndex: '10001 !important',
        width: '300px',
        height: '200px',
        backgroundColor: theme.palette.background.main,
        border: '1px solid ' + theme.palette.grey.variant3,
        display: 'flex',
        flexDirection: 'column'
    },
    autoPointerEvents: {
    },
    top: {
        zIndex: '1000 !important'
    },
    header: {
        backgroundColor: theme.palette.background.dark,
        borderTopLeftRadius: '6px',
        borderTopRightRadius: '6px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '25px',
        width: '301px'
    },
    layerName: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingLeft: '5px'
    },
    pages: {
        alignItems: 'center',
        position: 'relative',
        display: 'flex',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.light,
        clipPath: 'polygon(25% 0, 100% 0%, 100% 100%, 0% 100%)',
        width: '120px',
        height: '100%',
        justifyContent: 'space-between',
        borderTopRightRadius: '6px',
        boxSizing: 'border-box',
        paddingLeft: '30px'
    },
    link: {
        color: theme.palette.background.contrastText
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 0 10px 0',
        borderBottom: '1px solid ' + theme.palette.grey.variant3,
        margin: '10px 10px 0 10px'
    },
    titleText: {
        display: 'flex',
        alignItems: 'center',
        columnGap: '10px'
    },
    contrastText: {
        color: theme.palette.primary.contrastText
    },
    pointer: {
        cursor: 'pointer'
    },
    property: {
        padding: '10px 0',
        wordBreak: 'break-all'
    },
    properties: {
        maxHeight: '200px',
        overflowY: 'auto',
        padding: '10px',
        ...theme.components.scrollable
    },
    fillerIcon: {
        width: '20px',
        height: '20px'
    }
});

// const mapStateToProps = (state) => ({
//     highlightedFeatures: state.highlights.highlightedFeatures,
//     activeLayers: state.activeLayers,
//     layers: state.layers.layers
// });

const mapStateToProps = (state, ownProps) => {
    const highlightedFeatures = state.highlights.highlightedFeatures;
    const activeLayers = state.activeLayers;
    const currentPolygon = state.parcelPanel.polygons[state.parcelPanel.currentPolygonId];
    const layers = state.layers.layers;

    const feature = highlightedFeatures.length > 0 ? highlightedFeatures[0].features[0] : null;
    if (!feature) {
        return {
            highlightedFeatures: highlightedFeatures,
            activeLayers: activeLayers,
            layers: layers,
            siteCard: null
        };
    }

    const selectedLayer = layers.find(l => l.system_name === highlightedFeatures[0].layerSystemName);
    if (!selectedLayer) {
        return {
            highlightedFeatures: highlightedFeatures,
            activeLayers: activeLayers,
            layers: layers,
            siteCard: null
        };
    }

    const siteCard = state.siteCard.siteCards.find(el => {
        if (el.layerId === selectedLayer.id && el.featureId === feature.featureId) {
            return true;
        }
        const layerIsSiteCard = state.siteCard.siteCards.some(card => card.layerId === selectedLayer.id);
        return layerIsSiteCard;
    });

    return {
        highlightedFeatures: highlightedFeatures,
        activeLayers: activeLayers,
        layers: layers,
        siteCard: siteCard
    };
};


const mapDispatchToProps = (dispatch) => ({

});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles)
)(QueryFeatureInfoBox);